export const CREATE_CREDIT_NOTE = gql`
    mutation CreateCreditNote($input: CreditNoteInput!) {
        createCreditNote(input: $input) {
            id
            sageCreditNoteNumber
        }
    }
`;
